<template>
	<div class="box" style="margin-top: 80px;margin-bottom: 30px;">
		<allTitle ref="allTitle" />
		<lockPrice ref="lockPrice" />
		<loginDialog ref="loginDialog" />

		<el-dialog title="" class="oneFen" :visible.sync="productDialog" width="50%" v-dialogDrag @close="diaClose">
			<div>
				<video id="myVideo" class="video-js" :src="wdd" controls="controls" autoplay
					style="width: 100%; height: 500px" ref="myVideo">
					<source :src="wdd" type="video/mp4" />
				</video>
			</div>

		</el-dialog>
		<div class="catery-box">
			<div class="catery-big" @mouseleave="handleMouseLeave()">
				<div class="catery-big-item" v-for="(item, index) in newCateryList" :key="item.gId"
					@click="radioChange0(item)">
					<!-- :class="{ bgc2: wangNumber == item.gId }" -->
					<div
						style="position: absolute; top: 16px; right: 0; width: 1px; height: 50%; background-color: white">
					</div>
					<div>{{ item.label }}</div>
				</div>
			</div>
		</div>
		<div class="content2">

			<!-- <div class="mTwo">
				<div class="caterItem" v-for="(item, index) in allMaterList2" :key="item.value"
					@mouseenter="getMaterList3(item, index)" :class="{ bgc: index == sNumber }">
					{{ item.label }}
				</div>
			</div>
			<div class="mThree" v-show="allMaterList3.length > 0">
				<div class="caterItem" v-for="(item, index) in allMaterList3" :key="item.value"
					@click="radioChange4(item, allMaterList2[0].value, $route.query.id)">
					{{ item.label }}
				</div>
			</div> -->
			<div class="topInfo">

				<div class="priceBox">
					<div class="productBox">
						<div class="imglogo">
							<img src="../assets/newImg3/Logo - 搜原网 - syw@1x.png" alt="" />
						</div>
						<div class="produt" @click="showQou">
							{{ typeName }}
						</div>
						<img src="../assets/buyerCenter/c.png" style="width: 100%" />
					</div>
					<!-- <div class="location">
            <span>当前位置：</span>
            <div class="nav">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item style="cursor: pointer"><span
                    @click="skipPage('/quotedPrice')">产品行情</span></el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer"><span @click="goBack()">{{
              typeName
            }}</span></el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer"><span>产品价格中心</span></el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div> -->
					<!-- <div>
            <el-carousel height="365px" width="1317px" arrow="always">
              <el-carousel-item>
                <img src="../assets/zhnlImg/轮播图 大宗原材料商城，供应链金融 820x355 20240516.png"
                  style="width: 1317px; height: 365px" />
              </el-carousel-item>

              <el-carousel-item>
                <img src="../assets/3a1b573801371d71b0e81cc47263a05.png" style="width: 1317px; height: 365px" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/zhnlImg/1.png" style="width: 1317px; height: 365px" />
              </el-carousel-item>
            </el-carousel>
          </div> -->

					<div class="selectBox">
						<div class="btnBox">
							<div class="btn" v-for="(item, index) in MarketList"
								@click="marketChekout(index + 1, FactoryMarket[index].id)" :class="{
									btnBgc: marketChekoutFlag == index + 1,
									hhy: marketChekoutFlag != index + 1
								}" v-if="item.is_show == 1">
								{{ FactoryMarket[index].name }}
							</div>
							<!-- <div class="btn" @click="marketChekout(1, FactoryMarket[0].id)"
                                :class="{ 'btnBgc': marketChekoutFlag == 1 }">
                                {{ FactoryMarket[0].name }}
                            </div>
                            <div class="btn" @click="marketChekout(2, FactoryMarket[1].id)"
                                :class="{ 'btnBgc': marketChekoutFlag == 2 }">
                                {{ FactoryMarket[1].name }}

                            </div>
                            <div class="btn" @click="marketChekout(3, FactoryMarket[2].id)"
                                :class="{ 'btnBgc': marketChekoutFlag == 3 }">
                                {{ FactoryMarket[2].name }}
                            </div> -->
						</div>

						<div class="district" style="padding-bottom: 5px">
							<span
								style="margin-right: 50px; width: 52px; padding-bottom: 20px; font-size: 14px; font-weight: 290; color: #000000">区域：</span>
							<span style="margin-right: 50px; cursor: pointer; width: 46px" @click="quyuBtn1"
								:class="{ btnCol: quyuFlag == 1 }" class="hhe">不限</span>
							<div class="select hhe">
								<!-- <el-checkbox-group v-model="checkList" @change="checkListClick">
                  <el-checkbox :label="item.value" :value="item.value" v-for="(item, index) in areaCategoryList"
                    :key="item.value" @click="checkListClick">{{ item.name }}</el-checkbox>
                </el-checkbox-group> -->
								<el-radio-group v-model="radio" @change="radioChange1">
									<el-radio :label="item.id" v-for="(item, index) in areaCategoryList">{{ item.area
									}}</el-radio>
								</el-radio-group>
							</div>
						</div>
						<div class="district" style="padding-bottom: 5px">
							<span style="margin-right: 50px; width: 52px; padding-bottom: 20px">省份：</span>
							<span style="margin-right: 50px; cursor: pointer; width: 46px" @click="quyuBtn"
								:class="{ btnCol: quyuFlag2 == 1 }" class="hhe">不限</span>
							<div class="select hhe">
								<el-radio-group v-model="radio2" @change="radioChange2">
									<el-radio :label="item.rId" v-for="(item, index) in areaCategoryList2"
										style="padding-bottom: 12px" class="radioClass" :title="item.rName"> {{
											item.rName }}</el-radio>
								</el-radio-group>

							</div>
							<div style="color: rgb(32, 123, 255);padding-bottom: 4px;cursor: pointer;width: 82px;"
								v-show="ifShow1" @click="showAreaCategoryList2">显示全部 ↓</div>
							<div style="color: rgb(32, 123, 255);padding-bottom: 4px;cursor: pointer;width: 82px;"
								v-show="!ifShow1" @click="hiddenAreaCategoryList2">收起 ↑</div>
						</div>

						<div class="district" style="padding-bottom: 5px">
							<span style="margin-right: 50px; width: 52px; padding-bottom: 20px">企业：</span>
							<span style="margin-right: 50px; cursor: pointer; width: 46px" @click="shichangBtn2"
								:class="{ btnCol: shichang == 1 }" class="hhe">不限</span>
							<div class="select hhe">
								<el-radio-group v-model="radio3" @change="radioChange3">
									<el-radio :label="item?.busId" v-for="(item, index) in areaCategorySonList"
										style="padding-bottom: 12px" class="radioClass" :title="item.busNameAbbrev"> {{
											item?.busNameAbbrev
										}}</el-radio>
								</el-radio-group>
							</div>
							<div style=" color: rgb(32, 123, 255);padding-bottom: 4px;cursor: pointer;width: 82px;"
								v-show="ifShow2" @click="showAreaCategoryList">
								显示全部 ↓</div>
							<div style=" color: rgb(32, 123, 255);padding-bottom: 4px;cursor: pointer;width: 82px;"
								v-show="!ifShow2" @click="haddenAreaCategoryList">
								收起 ↑</div>

						</div>

						<div class="district" style="padding-bottom: 5px">
							<span style="margin-right: 50px; width: 48px; padding-bottom: 20px">规格：</span>
							<span style="margin-right: 50px; cursor: pointer; width: 46px" @click="shichangBtn4"
								:class="{ btnCol: shichang3 == 1 }" class="hhe">不限</span>
							<div class="select hhe">

								<el-radio-group v-model="radio5" @change="radioChangeProduct2">

									<el-radio :label="item?.bqType" v-for="(item, index) in areaCategorySonList3"
										:title="item?.bqType" class="radioClass" style="">
										<span>
											{{ item?.bqType }}
										</span>
									</el-radio>

								</el-radio-group>

								<el-input v-model="input" placeholder="请输入搜索型号" style="width: 120px;margin-right: 5px;"
									size="mini" @keyup.enter.native="toSearch"></el-input>
							</div>
							<div v-if="areaCategorySonList3.length > 0 && areaCategorySonList3.length < typeTotal"
								style="color:  rgb(32, 123, 255);text-align: center;padding: 6px 0px 20px 0px;cursor: pointer;width: 82px;"
								@click="handleCurrentChange">显示全部 ↓</div>
							<div v-else="areaCategorySonList3.length > 0 && areaCategorySonList3.length < typeTotal"
								style="color:  rgb(32, 123, 255);text-align: center;padding: 6px 0px;cursor: pointer;width: 82px;"
								@click="handleCurrentChange2">收起 ↑</div>
							<div>
							</div>


						</div>


					</div>
				</div>
			</div>

			<div class="quotedBox">
				<div class="h">
					<div class="checked" v-for="(item, index) in checkList">
						<span> {{ item }}</span>
					</div>
				</div>

				<div class="tableBox" style="position: relative">
					<el-table :data="tableData" border :row-class-name="tableRowClassName" ref="multipleTable"
						v-loading="tableLoading" :cell-style="{
							'text-align': 'center'
						}" :header-cell-style="{ 'text-align': 'center', height: '4px', background: '#227BFF', border: '0px solid #227BFF', color: 'white' }">
						<el-table-column prop="goodsName" label="商品名称">
							<template #default="scope">
								<div @click="toBus(scope.row)" style="cursor: pointer">
									{{ scope.row.goodsName }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="bqType" label="规格/参数">
							<template #default="scope">
								<div>
									{{ scope.row.bqType ? scope.row.bqType : "-" }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="busNameAbbrev" label="企业" width="200">
							<template #default="scope">
								<div @click="toBus(scope.row)" style="cursor: pointer">
									<span style="vertical-align: middle"> {{ scope.row.busNameAbbrev }}</span>
									<!-- <img src="../assets/newImg3/超级会员皇冠.png"
										style="vertical-align: middle; padding-left: 2px; width: 18px; height: 16px; margin-left: 1px"
										alt="" v-if="scope.row.isSupperVip == 1" />
									<img v-else-if="scope.row.isBusVip1 == 1" src="../assets/newImg3/黄金会员皇冠.png"
										style="vertical-align: middle; padding-left: 2px; width: 18px; height: 16px; margin-left: 1px"
										alt="" /> -->
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="bqCity" label="发货地">
							<template #default="scope">
								<div>
									{{ scope.row.bqCity ? scope.row.bqCity : scope.row.bqProvince }}
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="bqSpec" label="规格单位"></el-table-column>
						<el-table-column prop="currentPrice" :label="dataList[4]">
							<template #default="scope">
								<div>
									<span v-if="!user_id" @click="goLogin" style="cursor: pointer;">请先登录</span>
									<span v-else-if="user_id && subStatus">{{ scope.row.currentPrice != 0 ?
										scope.row.currentPrice : "-" }}</span>
									<span v-else-if="user_id" @click="toLock" style="cursor: pointer;">
										<i class="el-icon-lock"></i>
									</span>

								</div>
							</template>
						</el-table-column>
						<el-table-column prop="onePrice" :label="dataList[3]">
							<template #default="scope">
								<div>
									<span v-if="!user_id" @click="goLogin" style="cursor: pointer;">请先登录</span>
									<span v-else-if="user_id && subStatus">{{ scope.row.onePrice != 0 ?
										scope.row.onePrice : "-" }}</span>
									<span v-else-if="user_id" @click="toLock" style="cursor: pointer;">
										<i class="el-icon-lock"></i>
									</span>

								</div>
							</template>
						</el-table-column>
						<el-table-column prop="twoPrice" :label="dataList[2]">
							<template #default="scope">
								<div>
									<span v-if="!user_id" @click="goLogin" style="cursor: pointer;">请先登录</span>
									<span v-else-if="user_id && subStatus">{{ scope.row.twoPrice != 0 ?
										scope.row.twoPrice : "-" }}</span>
									<span v-else-if="user_id" @click="toLock(scope.row)" style="cursor: pointer;">
										<i class="el-icon-lock"></i>
									</span>
								</div>
							</template>
						</el-table-column>


						<el-table-column prop="onePrice" label="操作">
							<template #default="scope">
								<div>
									<el-button type="primary" size="mini" @click="toHistory(scope.row)">曲线图</el-button>
								</div>
							</template>
						</el-table-column>


					</el-table>
					<el-pagination layout=" sizes, prev, pager, next, jumper" :total="total"
						@size-change="handleSizeChangeOne" @current-change="handleCurrentChangeOne"
						v-model:page-size="size" :page-size="30" :page-sizes="[30]" :current-page="page"
						style="text-align: center;max-width: 95%;margin-top: 20px;">
					</el-pagination>
					<i class="el-icon-caret-right"
						style="position: absolute; right: 129px; top: 15px; font-size: 28px; z-index: 999"
						@click="rightLook" v-if="this.click_num > 0 && this.title2Flag == 0"></i>

					<i class="el-icon-caret-right"
						style="position: absolute; right: 129px; top: 26px; font-size: 28px; z-index: 999"
						@click="rightLook" v-if="this.click_num > 0 && this.title2Flag == 1"></i>
				</div>
			</div>
			<div class="priceBox3">
				<div class="left">
					<div><img src="../assets/newImg5/Icon-资讯.svg" style="vertical-align: middle;margin-top: 6px;"
							alt="">
					</div>
					<div class="leftItem">
						<span
							style="vertical-align: middle;margin-left: 10px;font-size: 18px;color: #000000;line-height: 36px;">
							资讯</span>

					</div>
				</div>
				<div class="right">
					<div><img src="../assets/newImg5/_Icon-商圈.svg" style="vertical-align: middle;margin-top: 6px;"
							alt="">
					</div>
					<div class="rightItem">
						<span
							style="vertical-align: middle;margin-left: 10px;font-size: 18px;color: #000000;line-height: 36px;">
							商圈</span>

					</div>
				</div>
			</div>
			<div class="circleBOX">
				<div class="cirLeft">
					<div class="consultTop">资讯动态</div>
					<div class="consultItem" v-for="(item, index) in consultList" :key="item.bgcId"
						@click="toTitle(item, 1)">
						<div class="top" :title="item.bgcTitle">
							{{ item.bgcTitle }}
						</div>
						<div class="bottom">
							<span>{{ item.addTime.slice(0, 11) }}</span>
							<span style="margin-left: 15px;">{{ item.realName }}</span>
						</div>
					</div>

				</div>
				<div class="cirMiddle">
					<div class="consultTop">行情走势分析</div>
					<div class="consultItem" v-for="(item, index) in titleList" @click="toTitle(item, 2)"
						:key="item.paId">
						<div class="top" :title="item.paTitle">
							{{ item.paTitle }}
						</div>
						<div class="bottom">
							<span>{{ item.addTime.slice(0, 11) }}</span>
							<span style="margin-left: 15px;">{{ item.realName
								}}</span>
						</div>
					</div>

				</div>
				<div class="cirRight">
					<div class="quanzi">
						<div class="quanziTop">
							<div>商圈推荐</div>
							<div style="font-size: 14px;font-weight: 290;cursor: pointer;" @click="changeCircle">
								<img src="../assets/newImg5/刷新.png" alt="" style="vertical-align: middle;">
								<span style="vertical-align: middle;padding-left: 3px">换一组</span>
							</div>
						</div>
						<div class="quanziContent" v-for="(item, index) in circleList" :key="item.cId"
							@click="goCircle(item.cId)" style="cursor: pointer;">
							<div class="left">
								<img :src="item.cHeadPic" style="width: 100%;height: 100%;border-radius: 5px;" alt="">
							</div>
							<div class="middle">
								<div
									style="color: #333333;font-size: 14px;padding-top: 4px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
									{{ item.cName }}</div>
								<div style="padding-top: 5px;color: #ADB0B7;font-size: 12px;">{{ item.memberNum
								}}人加入
								</div>
							</div>
							<div class="right" v-show="userName">
								<el-button type="primary" size="mini" style="margin-top: 11px;" v-if="item.isJoin == 0"
									@click.stop="addcircle(item)" plain>+ 加入</el-button>

								<el-button type="primary" size="mini" style="margin-top: 11px;"
									v-else-if="item.isJoin == 1" @click.stop="addcircle2(item)">已加入</el-button>
							</div>
						</div>

					</div>
					<div class="quanzi" style="margin-top: 10px;">
						<div class="quanziTop">
							<div>你可能感兴趣的人</div>
							<div style="font-size: 14px;font-weight: 290;cursor: pointer;" @click="changeCircle2">
								<img src="../assets/newImg5/刷新.png" alt="" style="vertical-align: middle;">
								<span style="vertical-align: middle;padding-left: 3px">换一组</span>
							</div>
						</div>
						<div class="quanziContent" v-for="(item, index) in userList" :key="item.userId"
							@click="goNav2('/creatorPage', item.userId)">
							<div class="left">
								<img :src="item.headPic" style="width: 100%;height: 100%;border-radius: 5px;" alt="">
							</div>
							<div class="middle">
								<div
									style="color: #333333;font-size: 14px;padding-top: 4px;white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
									{{ item.realName }}</div>
								<div style="padding-top: 5px;color: #ADB0B7;font-size: 12px;">{{ item.fansNum
								}}人关注
								</div>
							</div>
							<div class="right">
								<el-button type="primary" size="mini" style="margin-top: 12px;margin-left: 2px"
									v-if="item.isFans == 0" @click.stop="addFens(item)" plain>+ 关注</el-button>
								<el-button type="primary" size="mini" style="margin-top: 12px;margin-left: 2px"
									v-else-if="item.isFans == 1" @click.stop="addFens2(item)">已关注</el-button>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="priceBox2">
				<div><img src="../assets/newImg5/Icon-视频.svg" style="vertical-align: middle;margin-top: 6px;" alt="">
				</div>
				<div class="right">
					<span
						style="vertical-align: middle;margin-left: 10px;font-size: 18px;color: #000000;line-height: 36px;">
						百科视频</span>

				</div>
			</div>
			<div class="video">
				<div class="edit-box">

					<div class="edit-item" v-for="item in videoList" @click="toVedio(item)" :key="item.vId">
						<div style="position: relative;">
							<div style="position: absolute;bottom: 8px;right: 3px;font-size: 12px;color: #FFFFFF;">
								{{ item.vAddTime.slice(0, 10) }}
							</div>
							<img :src="item.vImgUrl"
								style="width: 100%;height: 116px;object-fit: cover;border-radius: 12px;" alt="">
						</div>
						<div style="color: #333333;font-size: 16px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
							:title="item.vTitle">
							{{ item.vTitle }}</div>
						<div style="color: gray;font-size: 12px;padding-top: 3px;color: #9499A0;">
							<img src="../assets/zhnlImg/Icon-YouTube@1x.png"
								style="vertical-align: middle;margin-right: 1px;" alt="">

							<span style="vertical-align: middle;">{{ item.vUploader }}</span>
						</div>
					</div>

				</div>
			</div>


		</div>
	</div>
</template>

<script>
import searchBar from "../components/searchBar.vue";
import classifyBar from "../components/classifyBar.vue";
import classifyContain from "../components/classifyContain.vue";
import loginCon from "../components/loginCon.vue";
import strictProduct from "../components/strictProduct.vue";
import product from "../components/product.vue";
import getParams from "../utils/getParams";
import dayjs from "dayjs";
import Vue from "vue";

import {
	getNotQGoodsConsult,
	getRegion,
	getAllVod,
	getSyVodByCatId,
	addCircleById,
	getAllBusManage,
	getRegionQuotation,
	getFatherCatBySonCat,
	getQuotationGName,
	getBstGoodsGategoryAndSon,
	getAreaById,
	getAreaByCatAndIndus,
	getPriceByAreaId,
	getBusByCatAndIndus,
	getBstGGateFatherById,
	addFollowByUserId,
	getUserByPage,
	getPredictArticleByCatId,
	getCircle,
	getGoodsGateStatusById,
	getBstGoodsGategory1ByPid
} from "@/api/user";
export default {
	data() {
		return {
			sNumber: null,
			allMaterList2: [],
			allMaterList3: [],
			cPage: 1,
			cSize: 4,
			user_id: localStorage.getItem('user_id'),
			subStatus: null,
			input: '',
			typeTotal: 0,
			typePage: 1,
			typeSize: 5,
			userList: [],
			titleList: [],
			circleList: [],
			consultList: [],
			weekAndMonth: [],
			userName: window.localStorage.getItem("userName"),

			total: null,
			totalPage: 0,
			totalPage2: 0,
			ifShow1: true,
			ifShow2: true,
			ifShow3: true,
			allPage: 0,
			tableLoading: false,
			page: 1,
			size: 30,
			areaCategorySonList4: [],
			show: true,
			areaCategorySonList3: [],
			areaCategorySonList3All: [],
			areaCategorySonList3Other: [],
			wdd: 'https://videos.zhnl.com/vod-e148ac/e04cd04f7ae771ef8d5c6733a68f0102/bc04df820ff84242b2235cf05bfe989a-c84cf76ac5d7487ac26cd5b8a43ec8fa-ld.mp4',
			productDialog: false,
			areaCategorySonList2: [],
			newCateryList: [],
			cateryShowList: [],
			wangNumber: 0,
			wangNumber2: -1,
			postData: {},
			imgList: ["../assets/index/banner.png"],
			videoList: [],
			productList: [],
			radio: "0",
			radio2: "",
			radio3: "",
			radio4: "",
			radio5: "",
			dataList: [],
			typeName: "",
			typeName2: "",

			tableData: [],
			marketChekoutFlag: 1,
			checkList: [],
			checkList2: [],
			//按钮标签
			quyuFlag: 1,
			shichang: 1,
			shichang2: 1,
			shichang3: 1,
			quyuFlag2: 1,
			pirceFlag: 1,

			//数据列表
			FactoryMarket: "",
			areaCategoryList: [

			],
			areaCategoryList2: [],
			areaCategoryList2All: [],
			areaCategoryList2Other: [],
			//出厂id
			market_house_id: 1,
			areaCategorySonList: [],
			areaCategorySonListAll: [],
			areaCategorySonListOther: [],
			//区域id
			shichangId: "",
			parent_id: "",
			dateData: [],
			cat_one: "",
			cat_two: "",
			click_num: 0,
			frequency: 1,
			goodName: "",
			title2Flag: 0,
			isRouterAlive: true,
			MarketList: "",
			search: "",
			area_two: 0
		};
	},

	methods: {
		diaClose() {
			this.productDialog = false
			this.$refs.myVideo.pause();
		},
		getMaterList3(row, index) {
			this.sNumber = index
			let threeList = this.allMaterList2.filter((item) => {
				return item.value == row.value
			})
			this.allMaterList3 = threeList[0].children
		},
		addcircle(item) {
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			addCircleById({ c_id: item.cId }).then((res) => {
				loading.close()

				if (res.data.code == 200) {
					this.titleShow(res.data.msg)
					getCircle({ page: this.cPage, size: 4, user_id: localStorage.getItem('user_id') }).then((res) => {
						this.circleList = res.data.data
					})
				} else {
					this.titleShow(res.data.msg)

				}
			})
		},
		goNav2(nav, ids) {
			if (!window.localStorage.getItem("user_id")) {
				return this.$refs.loginDialog.loginDialog();
			}
			const { href } = this.$router.resolve({
				path: nav,
				query: { id: ids }

			});
			window.open(href, "_blank");
		},
		toLock(row) {
			return this.$refs.lockPrice.getCode(row.catOne)

		},
		goLogin() {
			this.$refs.loginDialog.loginDialog();
		},
		toTitle(item, status) {
			console.log('123');

			if (status == 1) {
				const { href } = this.$router.resolve({
					path: "/enterTitleDetails",
					query: {
						id: item.bgcId,
						cat_one: this.$route.query.catOne,
						status: status
					}
				});
				window.open(href, "_blank");
			} else {
				if (this.subStatus != 1) {
					return this.$refs.lockPrice.getCode(item.catOne)
				}
				const { href } = this.$router.resolve({
					path: "/titleDetailsCopy",
					query: {
						id: item.paId
					}
				});
				window.open(href, "_blank");
			}
		},
		changeCircle() {
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			console.log(this.totalPage, 'this.totalPage');

			let num = Math.floor(this.totalPage / 4)
			console.log(num, 'num-----');

			let newNum = Math.floor(Math.random() * num) + 1
			if (this.page != newNum) {
				this.page = newNum
				this.cPage = newNum
				getCircle({ page: newNum, size: 4, user_id: localStorage.getItem('user_id') }).then((res) => {
					this.circleList = res.data.data?.slice(0, 4)
					loading.close()
				})
			} else {
				this.changeCircle()
			}

		},
		titleShow(msg) {
			this.$refs.allTitle.msg = msg
			this.$refs.allTitle.routerPath = null;
			this.$refs.allTitle.dialogVisible = true;
		},
		//关注
		addFens(item) {
			if (!window.localStorage.getItem("user_id")) {
				return this.$refs.loginDialog.loginDialog();
			}
			addFollowByUserId({ user_id: item.userId }).then((res) => {
				if (res.data.code == 200) {
					this.titleShow(res.data.msg)
					getUserByPage({ page: this.page2, size: 4 }).then((res) => {
						this.userList = res.data.data
					})
				} else {
					this.titleShow(res.data.msg)
				}
			})

		},
		addFens2(item) {
			if (!window.localStorage.getItem("user_id")) {
				return this.$refs.loginDialog.loginDialog();
			}
			addFollowByUserId({ user_id: item.userId }).then((res) => {
				if (res.data.code == 200) {
					this.titleShow(res.data.msg)
					getUserByPage({ page: this.page2, size: 4 }).then((res) => {
						this.userList = res.data.data
					})
				} else {
					this.titleShow(res.data.msg)
				}
			})

		},
		changeCircle2() {
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			let num = Math.floor(this.totalPage2 / 4)
			let newNum = Math.floor(Math.random() * num) + 1
			if (this.page2 != newNum) {
				this.page2 = newNum
				getUserByPage({ page: this.page2, size: 4 }).then((res) => {
					this.userList = res.data.data
					this.totalPage2 = res.data.totalPage
					loading.close()

				})
			} else {
				loading.close()
				this.changeCircle2()
			}
		},
		showAreaCategoryList2() {
			this.ifShow1 = false
			this.areaCategoryList2 = this.areaCategoryList2All
		},
		hiddenAreaCategoryList2() {
			this.ifShow1 = true
			this.areaCategoryList2 = this.areaCategoryList2Other
		},
		showAreaCategoryList() {
			this.ifShow2 = false
			this.areaCategorySonList = this.areaCategorySonListAll
		},
		haddenAreaCategoryList() {
			this.ifShow2 = true
			this.areaCategorySonList = this.areaCategorySonListOther
		},
		showAreaCategoryList3() {
			this.ifShow3 = false
			this.areaCategorySonList3 = this.areaCategorySonList3All
		},
		hiddenAreaCategoryList3() {
			this.ifShow3 = true
			this.areaCategorySonList3 = this.areaCategorySonList3Other
		},
		showAll() {
			this.areaCategorySonList3 = this.areaCategorySonList4
			this.show = false
		},
		toVedio(row) {
			const { href } = this.$router.resolve({
				path: "/vudio",
				query: {
					v_id: row.vId
				}
			});
			window.open(href, "_blank");
		},
		handleMouseEnter(indexs, gId) {
			this.wangNumber = gId;
			this.wangNumber2 = indexs;
			this.cateryShowList.forEach((item, index) => {
				this.cateryShowList[index] = false;
			});
			Vue.set(this.cateryShowList, indexs, true);
		},
		handleMouseLeave() {
			this.wangNumber = 0;
			this.cateryShowList.forEach((item, index) => {
				Vue.set(this.cateryShowList, index, false);
			});
		},
		goSearch() {
			const { href } = this.$router.resolve({
				path: "search",
				query: {
					activeName: "second"
				}
			});
			window.open(href, "_blank");
		},
		allVideo() {
			const { href } = this.$router.resolve({
				path: "search"
			});
			window.open(href, "_blank");
		},
		goBack() {
			this.$router.go(-1);
		},
		toHistory(row) {
			if (this.subStatus != 1) {
				return this.$refs.lockPrice.getCode(row.catOne)
			}
			const { href } = this.$router.resolve({
				path: "historicalQuotation",
				query: {
					catOne: row.catOne,
					catTwo: row.catTwo,
					catThree: row.catThree,
					catFour: row.catFour,
					goodName: row.goodsName,
					quotation_man: row.quotationMan,
					area_one: row.areaOne,
					area_two: row.areaTwo,
					bq_type: row.bqType
				}
			});
			window.open(href, "_blank");
		},

		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return "warning-row";
			} else if (rowIndex === 3) {
				return;
			}
		},
		toBus(row) {

			this.$router.push({
				path: "/facturerPage",
				query: {
					id: row.quotationMan
				}
			});
		},
		goTitle(item) {
			console.log(item, "item");
			this.$router.push({
				path: "/titleDetails",
				query: {
					id: item.bgcId
				}
			});
		},
		goVideo(data) {
			this.$router.push({
				path: "/vudio",
				query: {
					v_id: data.vId,
					industry: this.$route.query.cat_id,
					industry2: this.$route.query.cat_id2
				}
			});
		},
		radioChange1(e) {
			this.radio3 = "";
			this.radio2 = "";
			this.quyuFlag2 = 1;
			this.shichang = 1;
			this.quyuFlag = 0;
			let c = JSON.parse(this.$route.query.data);
			let dataNow = {
				id: e,
				cat_one: c.catOne,
				cat_two: c.catTwo,
				cat_three: c.catThree,
				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : ""
			};
			getPriceByAreaId(dataNow).then((res) => {
				this.areaCategoryList2 = res.data.data;
			});
			this.radio = e;
			this.getPrice();
		},
		radioChange2(e) {
			this.quyuFlag2 = 0;
			console.log(e, "222");
			this.radio2 = e;
			this.getPrice();
		},
		radioChange3(e) {
			this.shichang = 0;
			this.radio3 = e;
			this.getPrice();
		},

		radioChangeProduct(e) {
			this.shichang2 = 0;
			this.radio4 = e;
			this.getPrice();
		},
		radioChangeProduct2(e) {
			this.shichang3 = 0;
			this.radio5 = e;
			this.getPrice();
		},
		showQou() {
			if (this.wdd) {
				this.productDialog = true;
			}
		},

		radioChange4(e, item) {
			const { href } = this.$router.resolve({
				path: "/todayQuotedPriceCopy",
				query: {
					data: JSON.stringify({
						catOne: item.value,
						catTwo: e.value,
						label: e.label,

						cat_id: e.value
					})
				}
			});
			window.open(href, "_blank");
		},
		radioChange5(e, catTwo, catOne) {
			const { href } = this.$router.resolve({
				path: "/todayQuotedPrice",
				query: {
					data: JSON.stringify({
						catOne: catOne,
						catTwo: catTwo,
						catThree: e.value,
						label: e.label,
						cat_id: e.value
					})
				}
			});
			window.open(href, "_blank");
		},
		getPrice() {
			this.page = 1,
				this.size = 30
			this.tableLoading = true
			let data = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: data.catOne,
				cat_two: data.catTwo,
				cat_three: data.catThree,
				cat_four: data.catFour,
				industry: this.$route.query.cat_id,
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				area: this.radio,
				province: this.radio2,
				enterprise: this.radio3,
				goods_name: this.radio4,
				goods_type: this.radio5,
				page: this.page,
				size: this.size
			};
			getRegionQuotation(params).then((res) => {
				this.tableLoading = false
				this.tableData = res.data.data;
				this.total = res.data.totalPage
			});
		},
		handleSizeChangeOne(e) {

			this.page = 1;
			this.size = e;
			this.tableLoading = true
			let data = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: data.catOne,
				cat_two: data.catTwo,
				cat_three: data.catThree,
				cat_four: data.catFour,
				industry: this.$route.query.cat_id,
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				area: this.radio,
				province: this.radio2,
				enterprise: this.radio3,
				goods_name: this.radio4,
				goods_type: this.radio5,
				page: this.page,
				size: this.size
			};
			getRegionQuotation(params).then((res) => {
				this.tableLoading = false
				this.tableData = res.data.data;
				this.total = res.data.totalPage
			});


		},
		handleCurrentChangeOne(val) {

			this.page = val;
			this.tableLoading = true
			let data = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: data.catOne,
				cat_two: data.catTwo,
				cat_three: data.catThree,
				cat_four: data.catFour,
				industry: this.$route.query.cat_id,
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				area: this.radio,
				province: this.radio2,
				enterprise: this.radio3,
				goods_name: this.radio4,
				goods_type: this.radio5,
				page: this.page,
				size: this.size
			};
			getRegionQuotation(params).then((res) => {
				this.tableLoading = false
				this.tableData = res.data.data;
				this.total = res.data.totalPage
			});

		},
		handleSizeChange(e) {

			this.typePage = 1;
			this.typeSize = e;
			let c = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: c?.catOne,
				cat_two: c?.catTwo,
				cat_three: c?.catThree,
				cat_four: c?.catFour,
				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				page: this.typePage,
				size: this.typeSize,
				type: this.input
			};
			getQuotationGName(params).then((res) => {
				if (res.data.code == 200) {
					this.areaCategorySonList3 = res.data.data
					this.typeTotal = res.data.totalPage
				}
			});



		},
		toSearch() {
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			let c = JSON.parse(this.$route.query.data);
			this.typePage = 1
			let params = {
				cat_one: c?.catOne,
				cat_two: c?.catTwo,
				cat_three: c?.catThree,
				cat_four: c?.catFour,
				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				page: this.typePage,
				size: this.typeSize,
				type: this.input

			};
			getQuotationGName(params).then((res) => {
				loading.close()
				if (res.data.code == 200) {
					this.areaCategorySonList3 = res.data.data
					this.typeTotal = res.data.totalPage
				}
			});
		},
		handleCurrentChange(val) {
			// this.typeSize = 20
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			this.typePage += 1;
			let c = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: c?.catOne,
				cat_two: c?.catTwo,
				cat_three: c?.catThree,
				cat_four: c?.catFour,
				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				page: 1,
				size: 10000,
				type: this.input

			};
			getQuotationGName(params).then((res) => {
				loading.close()
				if (res.data.code == 200) {
					this.areaCategorySonList3 = [...res.data.data]
					this.typeTotal = res.data.totalPage
				}
			});


		},
		handleCurrentChange2(val) {
			// this.typeSize = 20
			const loading = this.$loading({
				lock: true,
				text: '',
				spinner: 'el-icon-loading',

				background: 'rgba(255, 255, 255, 0.2)'
			});
			this.typePage += 1;
			let c = JSON.parse(this.$route.query.data);
			let params = {
				cat_one: c?.catOne,
				cat_two: c?.catTwo,
				cat_three: c?.catThree,
				cat_four: c?.catFour,
				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
				page: 1,
				size: 6,
				type: this.input

			};
			getQuotationGName(params).then((res) => {
				loading.close()
				if (res.data.code == 200) {
					this.areaCategorySonList3 = [...res.data.data]
					this.typeTotal = res.data.totalPage
				}
			});


		},

		radioChange0(e) {
			let data = JSON.parse(this.$route.query.data)
			const { href } = this.$router.resolve({
				path: "/todayQuotedPrice",
				query: {
					data: JSON.stringify({
						catOne: data.catOne,
						catTwo: data.catTwo,
						catThree: e.gId,
						label: e.label,
						cat_id: e.gId
					})
				}
			});
			window.open(href, "_blank");
		},
		gotoPriceTrend(val) {
			const tableData = [
				{
					production: "白油", //第一
					name: "中国石油", //第二
					number: "123", //第三列
					count: 123 //第四列数据
				},
				{
					production: "红油",
					name: "美国石油",
					number: "132",
					count: 123
				},
				{
					production: "食用油",
					name: "非洲石油",
					number: "123",
					count: 123
				}
			];

			this.area_two = val.id;
			let objT = {};
			objT.name = this.goodName;
			objT.cat_one = this.cat_one;
			objT.cat_two = this.cat_two;
			objT.cat_three = this.cat_three;
			objT.market_house_id = this.market_house_id;
			objT.area_one = this.$route.query.parent_id;
			objT.area_two = this.area_two;
			objT.tableData = this.tableData;
			objT.dateData = this.dateData;

			this.skipPage("/priceTrend" + `?item=${JSON.stringify(objT)}`);
		},
		cellStyle() {
			return "'color': 'red'";
		},
		marketChekout(num, market_house_id) {
			this.marketChekoutFlag = num;
			this.parent_id = market_house_id;
			this.checkList = [];
			this.market_house_id = "";
			this.shichangId = "";
			this.dateData = [];
			this.tableData = [];
			this.areaCategory();
			this.fiveQuotedPriceList();
			this.fiveQuotedPriceList2();
			// this.areaCategorySon()
		},

		skipPage(page) {
			window.location = page;
		},
		quyuBtn1() {
			this.radio3 = "0";
			this.radio = "0";
			this.getPrice();
			this.quyuFlag = 1;
			let c = JSON.parse(this.$route.query.data);
			let dataNow = {
				id: 0,
				cat_one: c.catOne,
				cat_two: c.catTwo,
				cat_three: c.catThree,

				industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
				industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : ""
			};
			getPriceByAreaId(dataNow).then((res) => {
				this.areaCategoryList2 = res.data.data;
			});
			// if (this.quyuFlag == 0) {
			//   this.quyuFlag = 1;
			// } else {
			//   this.quyuFlag = 0;
			// }
			// if (this.quyuFlag == 0) {
			//   this.quyuFlag = 1;
			//   this.market_house_id = "";
			//   this.checkList = [];
			//   this.areaCategorySon();
			// } else {
			//   this.quyuFlag = 0;
			// }
		},
		//选择框按钮事件
		quyuBtn() {
			this.radio2 = "";
			this.getPrice();
			this.quyuFlag2 = 1;
			// if (this.quyuFlag2 == 0) {
			//   this.quyuFlag2 = 1;
			// } else {
			//   this.quyuFlag2 = 0;
			// }
			// if (this.quyuFlag == 0) {
			//   this.quyuFlag = 1;
			//   this.market_house_id = "";
			//   this.checkList = [];
			//   this.areaCategorySon();
			// } else {
			//   this.quyuFlag = 0;
			// }
		},

		//选择框按钮事件
		shichangBtn2() {
			this.radio3 = "";
			this.shichang = 1;
			this.getPrice();
		},
		shichangBtn3() {
			this.radio4 = "";
			this.shichang2 = 1;
			this.getPrice();
		},
		shichangBtn4() {
			this.radio5 = "";
			this.shichang3 = 1;
			this.getPrice();
		},

		checkListClick(e) {
			console.log(this.checkList, "checkList");
			console.log(e, 111);
			if (this.checkList.length >= 1) {
				this.quyuFlag = 0;
			}
			if (e.length > 0) {
				let arr = [];
				this.areaCategoryList.forEach((item, index) => {
					// e.forEach((item2, index2) => {
					// console.log('123', item.name)

					//     if (item.name == item2) {

					//         arr.push[item[index].id]

					//     }
					// })
					for (var i = 0; i < e.length; i++) {
						if (item.name == e[i]) {
							arr.push(item.id);
						}
					}
				});

				this.market_house_id = arr.join();
				this.dateData = [];
				this.tableData = [];
				this.areaCategorySon();
				this.fiveQuotedPriceList();
			}
		},
		shichangBtn() {
			if (this.shichang == 0) {
				this.shichang = 1;
			} else {
				this.shichang = 0;
			}
		},
		checkList2Click(e) {
			console.log(this.radio3, "cecece");
			if (this.checkList2.length >= 1) {
				this.shichang = 0;
			}
			if (e.length > 0) {
				let arr = [];
				this.areaCategorySonList.forEach((item, index) => {
					// e.forEach((item2, index2) => {
					// console.log('123', item.name)

					//     if (item.name == item2) {

					//         arr.push[item[index].id]

					//     }
					// })
					for (var i = 0; i < e.length; i++) {
						if (item.name == e[i]) {
							arr.push(item.id);
						}
					}
				});
				this.shichangId = arr.join();
				this.fiveQuotedPriceList();
				this.fiveQuotedPriceList2();

				this.isRouterAlive = false; // 1.让组件消失
				this.$nextTick(() => {
					this.isRouterAlive = true; // 在nextTick方法中，再让组件重现，完成重载
				});
			} else {
			}
		},
		pirceBtn(num) {
			this.pirceFlag = num;
			this.frequency = num;
			this.fiveQuotedPriceList();
			this.fiveQuotedPriceList2();
			this.$nextTick(() => {
				this.isRouterAlive = true; // 在nextTick方法中，再让组件重现，完成重载
			});
		},
		clear() {
			this.checkList = [];
			this.checkList2 = [];
			this.market_house_id = "";
			this.shichangId = "";
			this.quyuFlag = 0;
			this.shichang = 0;
		},

		changeCellStyle(row, column, rowIndex, columnIndex) {
			//列的label的名称
			if (row.column.label != "市场" && row.column.label != "单位") {
				return "text-align: center; color:black"; //修改的样式
			} else {
				return "text-align: center;";
			}
		},

		//数据表往左
		leftLook() {
			this.click_num = this.click_num + 1;
			this.fiveQuotedPriceList();
		},

		//数据表往右
		rightLook() {
			this.click_num = this.click_num - 1;
			this.fiveQuotedPriceList();
		},

		//出厂列表
		async ExFactoryMarket() {
			let res = await this.$http("/mini/ApiConnect/ExFactoryMarket");
			this.FactoryMarket = res.result;
			if (!getParams().parent_id) {
				this.parent_id = this.FactoryMarket[0].id;
			}
			this.MarketList = res.result;
			// this.parent_id = ''

			this.areaCategory();
		},

		//区域列表
		async areaCategory() {
			let res = await this.$http("/mini/ApiConnect/areaCategory", {
				market_house_id: this.parent_id
			});
			this.areaCategoryList = res.result;
			if (!getParams().market_house_id) {
				this.market_house_id = "";
			}
			// this.parent_id = ''

			this.areaCategorySon();
		},

		//市场列表


		//报价列表
		async fiveQuotedPriceList() {
			let parmas = {
				frequency: this.frequency,
				cat_one: this.cat_one,
				cat_two: this.cat_two,
				cat_three: this.cat_three,
				market_house_id: this.parent_id,
				area_one: this.market_house_id,
				area_two: this.shichangId,
				click_num: this.click_num
			};
			let res = await this.$http("/mini/ApiConnect/fiveQuotedPriceList", parmas);
			this.dateData = [];
			res.result[0]?.son.forEach((e, index) => {
				if (e.title && e.title2) {
					this.dateData.push(e.title + "\n" + e.title2);
					this.title2Flag = 1;
				} else {
					this.dateData.push(e.title);
					this.title2Flag = 0;
				}
			});
			this.tableData = [];

			res.result.forEach((e, index) => {
				let obj = {};
				obj.shichang = e.name;
				obj.date1 = e?.son[0].price;
				obj.date2 = e?.son[1].price;
				obj.date3 = e?.son[2].price;
				obj.date4 = e?.son[3].price;
				obj.date5 = e?.son[4].price;
				obj.danwei = e?.son[0].unit;
				obj.id = e.id;
				// this.$set(this.tableData, index, obj)
				this.tableData.push(obj);
				console.log("tableData", index);
			});
		},

		async fiveQuotedPriceList2() {
			let parmas = {
				frequency: this.frequency,
				cat_one: this.cat_one,
				cat_two: this.cat_two,
				cat_three: this.cat_three,
				market_house_id: this.parent_id,
				area_one: this.market_house_id,
				area_two: this.shichangId,
				click_num: this.click_num,
				fun: 1
			};
			let res = await this.$http("/mini/ApiConnect/fiveQuotedPriceList", parmas);

			res.result.forEach((e, index) => {
				if (this.tableData[index].yData) {
					this.tableData[index].yData = e.data;
				}
				if (this.tableData[index].xData) {
					this.tableData[index].xData = e.title;
				}
			});
		}
	},
	mounted() {

		let c = JSON.parse(this.$route.query.data);
		getBstGoodsGategory1ByPid({ p_id: [c.catTwo] }).then((res) => {
			this.newCateryList = res.data.data

		})
		if (window.localStorage.getItem("user_id")) {
			getGoodsGateStatusById({ cat_one: c?.catOne, }).then((res) => {
				if (res.data.code == 200) {
					this.subStatus = res.data.data
				} else {

				}
			})
		}
		// getBstGoodsGategoryAndSon().then((res) => {
		// 	this.newCateryList = res.data.data;
		// 	this.newCateryList.forEach((item, index) => {
		// 		this.cateryShowList[index] = false;
		// 	});
		// });
		this.$bus.$on("zfSuccess", (data) => {

			this.subStatus = 1

		});
		this.$bus.$on("loginSuccess", (data) => {
			getGoodsGateStatusById({ cat_one: this.$route.query.id, }).then((res) => {
				if (res.data.code == 200) {
					this.subStatus = res.data.data
				} else {

				}
			})
			this.user_id = localStorage.getItem('user_id'),
				getQuotByParams(params).then((res) => {
					this.tableList2 = res.data.data;
				});
		});
		this.$bus.$on("loginCancel", (data) => {
			this.user_id = null
		}
		)
		let param3 = {
			cat_one: c?.catOne,
			page: 1,
			size: 10,
			param: '',
			is_info: 1,
		}
		let params2 = {
			cat_one: c?.catOne,
			cat_two: null,
			cat_three: null,
			cat_four: null,
			size: 10,
			page: 1,

		};
		getCircle({ page: this.cPage, size: this.cSize, user_id: localStorage.getItem('user_id') }).then((res) => {
			this.circleList = res.data.data
			this.totalPage = res.data.totalPage
		})
		getUserByPage({ c_id: '', page: 1, size: 4 }).then((res) => {
			this.userList = res.data.data
			this.totalPage2 = res.data.totalPage
		})
		getPredictArticleByCatId(params2).then((res) => {
			this.titleList = res.data.data
		})
		getNotQGoodsConsult(param3).then((res) => {
			this.consultList = res.data.data
		})
		let param4 = {
			cat_one: this.$route.query.id,
			page: 1,
			size: 5,
			param: '',
			is_info: 4,
		}
		getNotQGoodsConsult(param4).then((res) => {
			this.weekAndMonth = res.data.data
		})

		getSyVodByCatId({
			cat_one: c?.catOne,
			cat_two: c?.catTwo,
			cat_three: c?.catThree,
			cat_four: c?.catFour,
		}).then((res) => {
			this.wdd = res.data.data?.videoUrl
		})
		if (c.cat_id) {
			getBstGGateFatherById({ cat_id: c.cat_id }).then((res) => {
				if (res.data.code == 200) {
					var params2 = {
						cat_one: res.data.data,
						cat_two: "",
						cat_three: "",
						industry: "",
						industry2: "",
						page: 1,
						size: 10,
					};

					getAllVod(params2).then((res) => {
						this.videoList = res.data.data;
					});
				}
			});
		} else {
			getBstGGateFatherById({ cat_id: c.catTwo }).then((res) => {
				if (res.data.code == 200) {
					var params2 = {
						cat_one: res.data.data,
						cat_two: "",
						cat_three: "",
						industry: "",
						industry2: "",
						page: 1,
						size: 30
					};

					getAllVod(params2).then((res) => {
						this.videoList = res.data.data;
					});
				}
			});
		}

		this.postData = JSON.parse(this.$route.query.data);
		this.typeName = this.postData.label;

		let params = {
			cat_one: c?.catOne,
			cat_two: c?.catTwo,
			cat_three: c?.catThree,
			cat_four: c?.catFour,
			industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
			industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : "",
			page: this.typePage,
			size: this.typeSize,
			type: this.input
		};
		getQuotationGName(params).then((res) => {
			if (res.data.code == 200) {
				this.areaCategorySonList3 = res.data.data
				this.typeTotal = res.data.totalPage
			}
		});

		getBusByCatAndIndus(params).then((res) => {
			this.areaCategorySonList = res.data.data.slice(0, 5);
			this.areaCategorySonListOther = res.data.data.slice(0, 5);
			this.areaCategorySonListAll = res.data.data;
		});
		getAreaByCatAndIndus(params).then((res) => {
			this.areaCategoryList = res.data.data;
		});
		let dataNow = {
			id: "0",
			cat_one: c.catOne,
			cat_two: c.catTwo,
			cat_three: c.catThree,
			cat_three: c.catThree,
			industry: this.$route.query.cat_id != undefined ? this.$route.query.cat_id : "",
			industry2: this.$route.query.cat_id2 != undefined ? this.$route.query.cat_id2 : ""
		};
		getPriceByAreaId(dataNow).then((res) => {
			this.areaCategoryList2 = res.data.data.slice(0, 6);
			this.areaCategoryList2All = res.data.data;
			this.areaCategoryList2Other = res.data.data.slice(0, 6);
		});
		// 获取当前日期
		let today = dayjs();
		// 创建一个空数组来存储日期
		// let datesArray = [];
		// 循环四次，获取前四天的日期
		for (let i = 4; i >= 0; i--) {
			this.dataList.push(today.subtract(i, "day").format("MM-DD"));
		}
		let data = JSON.parse(this.$route.query.data);
		this.goodName = data.goods_name;
		this.getPrice();

	},
	components: {
		searchBar,
		classifyBar,
		classifyContain,
		loginCon,
		strictProduct,
		product,
	}
};
</script>

<style lang="scss">
.radioClass {
	padding-bottom: 7px;
	padding-top: 5px;
	display: inline-block;
	width: 102px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap !important;
}

.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
	color: #006eb7;
	font-size: 14px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
	color: #006eb7;
	font-size: 14px !important;
}

.el-table .cell {
	white-space: pre-wrap !important;
}
</style>

<style lang="scss" scoped>
.btnCol {
	color: #227bff;
	font-weight: 700;
}


.hhe {
	width: 980px;
}

.catery-box {
	width: 100vw;
	min-height: 55px;
	margin-top: 80px;
	background: linear-gradient(93deg, #227bff 0%, #5f9efa 51%, #227bff 99%);

	.catery-big {
		width: 1000px;
		margin: auto;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-around;

		.catery-big-item {
			cursor: pointer;
			position: relative;
			margin-top: 1.4px;
			box-sizing: border-box;
			color: #ffffff;
			font-size: 16px;
			font-weight: 400;
			height: 49px;
			width: 14.1%;
			line-height: 44px;
			padding: 5px 0px;
			text-align: center;
			box-sizing: border-box;
			position: relative;
			white-space: nowrap;
			overflow: hidden;
			display: inline-block;
			text-overflow: ellipsis;

			.catery-absolute {
				// border-radius: 8px;
				position: absolute;
				width: 600%;
				display: flex;
				flex-wrap: wrap;
				top: 44px;
				background-color: white;
				z-index: 999;

				.absolute-item {
					line-height: 30px;
					display: flex;
					flex-wrap: nowrap;
					word-wrap: break-word;
					width: 100%;
					margin: auto;
					padding: 3px 10px;
					box-sizing: border-box;
					border-bottom: 1px solid #d8d8d8;

					.absolute-left {
						height: 30px;
						cursor: pointer;
						box-sizing: border-box;
						padding: 2px 10px;
						text-align: left;
						color: #227bff;
						font-weight: 400;
						font-size: 14px;
						box-sizing: border-box;
						white-space: nowrap;
					}

					.absolute-right {
						color: #333333;
						font-size: 14px;
						font-weight: 400;
						height: 100%;
						text-align: left;
						display: flex;
						flex-wrap: wrap;

						.changeColor:hover {
							color: #006eb7;
						}
					}
				}
			}
		}
	}
}



.content2 {
	width: 1000px;
	margin: auto;
	display: flex;
	flex-direction: column;

	.bgc {
		background-color: rgb(26, 102, 251);
		color: white;
		border-radius: 20px;
	}

	.bgc2 {
		color: #227bff;
	}

	.mOne {
		font-size: 30px;
		font-weight: 900;
		font-style: italic;
		margin-left: 8px;
	}

	.mTwo {
		width: 100%;
		display: flex;
		margin-top: 8px;
		color: #333333;
		margin-bottom: 8px;

		.caterItem {
			padding: 6px 13px;
			margin-right: 6px;
			border-right: 1px solid #EBEEF5;
		}
	}

	.mThree {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		color: #333333;
		margin-bottom: 8px;

		.caterItem {
			padding: 6px 10px;
			cursor: pointer;
		}

		.caterItem:hover {
			color: #227bff;
		}
	}

	.priceBox2 {
		width: 100%;
		display: flex;
		height: 40px;

		.right {
			width: 100%;
			background-image: linear-gradient(to right, white, rgb(115, 171, 246));
			padding: 2px 0px;
			border-radius: 0px 10px 10px 0px;
		}
	}

	.priceBox3 {
		width: 100%;
		display: flex;
		height: 40px;

		.left {
			display: flex;
			width: 68%;
			padding: 2px 0px;
			border-radius: 0px 10px 10px 0px;

			.leftItem {
				width: 100%;
				background-image: linear-gradient(to right, white, rgb(115, 171, 246));
				padding: 2px 0px;
				border-radius: 0px 10px 10px 0px;
			}
		}

		.right {
			display: flex;
			width: 28%;
			padding: 2px 0px;
			border-radius: 0px 10px 10px 0px;
			margin-left: 20px;

			.rightItem {
				width: 100%;
				background-image: linear-gradient(to right, white, rgb(115, 171, 246));
				padding: 2px 0px;
				border-radius: 0px 10px 10px 0px;
			}
		}

		// .right {
		//     width: 70%;
		//     background-image: linear-gradient(to right, white, rgb(115, 171, 246));
		//     padding: 2px 0px;
		//     border-radius: 0px 10px 10px 0px;
		// }
	}

	.circleBOX {
		width: 100%;
		height: 640px;
		display: flex;

		.cirLeft {
			width: 32%;
			margin-right: 3%;
			height: 100%;
			margin-top: 8px;

			.consultTop {
				display: flex;
				justify-content: space-between;
				font-size: 16px;
				font-weight: 500;
				// border-bottom: 1px solid #EBEEF5;
				padding: 6px 8px 16px;
			}



			.consultItem {
				width: 100%;
				height: 58px;
				box-sizing: border-box;
				padding: 8px 6px;
				border-bottom: 1px solid #EBEEF5;
				cursor: pointer;

				.top {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 14px;
				}

				.bottom {
					padding-top: 4px;
					font-size: 12px;
					color: #999999;
				}
			}
		}

		.cirMiddle {
			width: 32%;
			height: 100%;
			margin-top: 8px;
			margin-right: 3%;

			.consultTop {
				display: flex;
				justify-content: space-between;
				font-size: 16px;
				font-weight: 500;
				// border-bottom: 1px solid #EBEEF5;
				padding: 6px 8px 16px;
			}



			.consultItem {
				cursor: pointer;
				width: 100%;
				height: 58px;
				box-sizing: border-box;
				padding: 8px 6px;
				border-bottom: 1px solid #EBEEF5;

				.top {
					font-size: 14px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis
				}

				.bottom {
					padding-top: 4px;
					font-size: 12px;
					color: #999999;
				}
			}
		}

		.cirRight {
			width: 32%;

			.quanzi {
				width: 100%;
				height: 298px;
				background-color: white;
				border-radius: 10px;

				.noticeItem2 {
					width: 90%;
					height: 26px;
					padding: 6px 12px;
					white-space: nowrap;

					.title {
						color: #535861;
						font-size: 16px;
						white-space: nowrap;
						overflow: hidden;
						display: inline-block;
						text-overflow: ellipsis;
						max-width: 70%;
						cursor: pointer;
					}

					img {
						margin-top: 3px;
						margin-right: 10px;
						width: 25px;
						height: 20px;
					}
				}

				.noticeItem3 {
					width: 90%;
					height: 26px;
					padding: 6px 21px;
					white-space: nowrap;

					.title {
						color: #535861;
						font-size: 16px;
						white-space: nowrap;
						overflow: hidden;
						display: inline-block;
						text-overflow: ellipsis;
						max-width: 70%;
						cursor: pointer;
					}

				}

				.quanziTop {
					width: 100%;
					height: 55px;
					line-height: 56px;
					padding: 0px 28px 0px 20px;
					color: #333333;
					font-size: 18px;
					font-weight: 500;
					display: flex;
					justify-content: space-between;
					box-sizing: border-box;
				}

				.quanziContent {
					width: 100%;
					display: flex;
					padding: 0px 8px 10px 20px;
					cursor: pointer;
					box-sizing: border-box;

					.left {
						width: 50px;
						height: 50px
					}

					.middle {
						width: 130px;
						height: 50px;
						padding-left: 13px;
					}

					.right {
						padding-left: 6px;
					}
				}
			}
		}
	}

	.video {
		width: 100%;
		margin-bottom: 30px;

		.edit-box {
			width: 100%;
			flex-wrap: wrap;
			display: flex;
			gap: 0;
			align-content: flex-start;
			justify-content: flex-start;
			margin-top: 12px;

			.edit-item {
				box-sizing: border-box;
				cursor: pointer;
				width: 200px;
				height: 174px;
				padding: 0px 6px;
				// background-color: skyblue;
			}
		}
	}
}

.selectBox {
	width: 1000px;
	// background-color: red;
	box-sizing: border-box;
	border-radius: 4px;
	padding: 12px 0px;
	margin-top: 18px;
	// height: 292px;

	.btnBox {
		display: flex;
		align-items: center;
		margin-top: 10px;

		.btn {
			margin-right: 35px;
			width: 81px;
			height: 28px;
			border-radius: 14px;
			border: 1px solid #006eb7;
			color: #006eb7;
			box-sizing: border-box;
			text-align: center;
			line-height: 28px;
			font-size: 14px;
			cursor: pointer;
		}

		.btnBgc {
			background-color: #006eb7 !important;
			color: white !important;
			border: none !important;
		}
	}

	.district {
		font-size: 12px;
		padding: 20px 14px;
		box-sizing: border-box;
		width: 100%;
		border-bottom: 1px solid #e4e4e4;
		display: flex;
		align-items: flex-start;
	}

	:deep(.el-checkbox) {
		width: 100px;
		margin-bottom: 10px;
	}

	:deep(.el-checkbox__label) {
		margin-top: 1px;
		font-size: 16px;
		margin-right: 53px;
		font-size: 12px;
	}

	:deep(.el-checkbox__inner) {
		font-size: 12px;
	}

	.checkedBox {
		display: flex;
		align-items: center;
		padding: 20px;
		box-sizing: border-box;

		.checked {
			height: 28px;
			border-radius: 14px;
			background: #006eb7;
			text-align: center;
			padding: 4px 10px;
			box-sizing: border-box;
			color: white;
			margin-right: 32px;
		}

		.clear {
			font-size: 12px;
			width: 69px;
			height: 28px;
			border-radius: 14px;
			border: 1px solid #006eb7;
			color: #006eb7;
			cursor: pointer;
		}
	}
}

.video {
	width: 100%;

	.edit-box {
		width: 100%;
		flex-wrap: wrap;
		display: flex;
		gap: 0;
		align-content: flex-start;
		justify-content: flex-start;
		margin-top: 14px;

		.edit-item {
			box-sizing: border-box;
			cursor: pointer;
			width: 250px;
			height: 174px;
			padding: 0px 15px;
			// background-color: skyblue;
		}
	}
}

.quotedBox {
	width: 1000px;
	margin-top: 0px;
	margin-bottom: 2px;
	padding: 24px 0px;
	box-sizing: border-box;
	background-color: white;

	.h {
		display: flex;
		align-items: center;

		box-sizing: border-box;

		.checked {
			height: 28px;
			border-radius: 14px;
			background: #006eb7;
			text-align: center;
			padding: 4px 10px;
			box-sizing: border-box;
			color: white;
			margin-right: 32px;
		}
	}

	.tableBox {
		margin-top: 22px;
		border-top: 1px solid #e4e4e4;
	}

	.title {
		width: 83px;
		height: 28px;
		border-radius: 14px;
		background: #006eb7;
		font-size: 12px;
		text-align: center;
		line-height: 28px;
		color: white;
	}

	:deep(.el-table .el-table__cell) {
		padding: 17px 0 !important;
		white-space: pre-wrap !important;
	}
}

.video-content {
	cursor: pointer;
	width: 100%;
	// height: 1080px;
	background-color: white;
	margin-bottom: 100px;

	.video-title {
		width: 100%;
		height: 50px;
		// background-color: skyblue;
		// background-image: linear-gradient(rgb(212, 230, 255), white);

		// padding-left: 5px;
		line-height: 50px;
		display: flex;
		justify-content: space-between;
	}

	.video-bottom {
		height: 600px;
		width: 100%;
		display: flex;
		// flex-flow: column wrap;
		background-color: white;
		flex-wrap: wrap;

		.video-bottom-box {
			padding: 5px 10px;
			width: 20%;
			height: 158px;
			box-sizing: border-box;

			.box-img {
				width: 100%;
				height: 116px;
			}

			.video-img:hover {
				box-shadow: 5px 5px 5px gray;
			}

			.box-title {
				width: 100%;
				height: 21px;
				white-space: nowrap;
				/* 文本不换行 */
				overflow: hidden;
				/* 溢出部分隐藏 */
				text-overflow: ellipsis;
				padding-top: 5px;
				font-weight: 900;
			}

			.box-title:hover {
				color: rgb(32, 123, 255) !important;
			}

			.box-title2:hover {
				color: rgb(32, 123, 255) !important;
			}

			.box-title2 {
				color: gray;
				width: 100%;
				height: 21px;
				display: flex;
			}
		}
	}
}


// @media screen and (min-width: 1680px) and (max-width: 10620px) {
// 	.hhe {
// 		width: 1220px;
// 	}

// 	.catery-box {
// 		width: 100vw;
// 		height: 100px;
// 		margin-top: 80px;
// 		background: linear-gradient(93deg, #227bff 0%, #5f9efa 51%, #227bff 99%);

// 		.catery-big {
// 			width: 1500px;
// 			margin: auto;
// 			height: 100%;
// 			display: flex;
// 			flex-wrap: wrap;

// 			.catery-big-item {
// 				position: relative;
// 				cursor: pointer;

// 				margin-top: 1.4px;
// 				box-sizing: border-box;
// 				color: #ffffff;
// 				font-size: 16px;
// 				font-weight: 400;
// 				height: 44px;
// 				width: 10%;
// 				line-height: 44px;
// 				padding: 1px 0px;
// 				text-align: center;
// 				box-sizing: border-box;
// 				position: relative;

// 				.catery-absolute {
// 					// border-radius: 8px;
// 					position: absolute;
// 					width: 600%;
// 					display: flex;
// 					flex-wrap: wrap;
// 					top: 44px;
// 					background-color: white;
// 					z-index: 999;

// 					.absolute-item {
// 						line-height: 30px;
// 						display: flex;
// 						flex-wrap: nowrap;
// 						word-wrap: break-word;
// 						width: 100%;
// 						margin: auto;
// 						padding: 3px 10px;
// 						box-sizing: border-box;
// 						border-bottom: 1px solid #d8d8d8;

// 						.absolute-left {
// 							height: 30px;
// 							cursor: pointer;
// 							box-sizing: border-box;
// 							padding: 2px 10px;
// 							text-align: left;
// 							color: #227bff;
// 							font-weight: 400;
// 							font-size: 14px;
// 							box-sizing: border-box;
// 							white-space: nowrap;
// 						}

// 						.absolute-right {
// 							color: #333333;
// 							font-size: 14px;
// 							font-weight: 400;
// 							height: 100%;
// 							text-align: left;
// 							display: flex;
// 							flex-wrap: wrap;

// 							.changeColor:hover {
// 								color: #006eb7;
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}

// 	.content2 {
// 		width: 1500px;
// 		margin: auto;
// 		display: flex;
// 		flex-direction: column;
// 	}

// 	.selectBox {
// 		width: 1500px;
// 		// background-color: red;
// 		box-sizing: border-box;
// 		border-radius: 4px;
// 		padding: 12px 0px;
// 		margin-top: 18px;
// 		// height: 292px;

// 		.btnBox {
// 			display: flex;
// 			align-items: center;
// 			margin-top: 10px;

// 			.btn {
// 				margin-right: 35px;
// 				width: 81px;
// 				height: 28px;
// 				border-radius: 14px;
// 				border: 1px solid #006eb7;
// 				color: #006eb7;
// 				box-sizing: border-box;
// 				text-align: center;
// 				line-height: 28px;
// 				font-size: 14px;
// 				cursor: pointer;
// 			}

// 			.btnBgc {
// 				background-color: #006eb7 !important;
// 				color: white !important;
// 				border: none !important;
// 			}
// 		}

// 		.district {
// 			font-size: 12px;
// 			padding: 20px 14px;
// 			box-sizing: border-box;
// 			width: 100%;
// 			border-bottom: 1px solid #e4e4e4;
// 			display: flex;
// 			align-items: flex-start;
// 		}

// 		:deep(.el-checkbox) {
// 			width: 100px;
// 			margin-bottom: 10px;
// 		}

// 		:deep(.el-checkbox__label) {
// 			margin-top: 1px;
// 			font-size: 16px;
// 			margin-right: 53px;
// 			font-size: 12px;
// 		}

// 		:deep(.el-checkbox__inner) {
// 			font-size: 12px;
// 		}

// 		.checkedBox {
// 			display: flex;
// 			align-items: center;
// 			padding: 20px;
// 			box-sizing: border-box;

// 			.checked {
// 				height: 28px;
// 				border-radius: 14px;
// 				background: #006eb7;
// 				text-align: center;
// 				padding: 4px 10px;
// 				box-sizing: border-box;
// 				color: white;
// 				margin-right: 32px;
// 			}

// 			.clear {
// 				font-size: 12px;
// 				width: 69px;
// 				height: 28px;
// 				border-radius: 14px;
// 				border: 1px solid #006eb7;
// 				color: #006eb7;
// 				cursor: pointer;
// 			}
// 		}
// 	}

// 	.video {
// 		width: 100%;

// 		.edit-box {
// 			width: 100%;
// 			flex-wrap: wrap;
// 			display: flex;
// 			gap: 0;
// 			align-content: flex-start;
// 			justify-content: flex-start;
// 			margin-top: 14px;

// 			.edit-item {
// 				box-sizing: border-box;
// 				cursor: pointer;
// 				width: 250px;
// 				height: 174px;
// 				padding: 0px 15px;
// 				// background-color: skyblue;
// 			}
// 		}
// 	}

// 	.quotedBox {
// 		width: 1500px;
// 		margin-top: 0px;
// 		margin-bottom: 20px;
// 		padding: 24px 0px;
// 		box-sizing: border-box;
// 		background-color: white;

// 		.h {
// 			display: flex;
// 			align-items: center;

// 			box-sizing: border-box;

// 			.checked {
// 				height: 28px;
// 				border-radius: 14px;
// 				background: #006eb7;
// 				text-align: center;
// 				padding: 4px 10px;
// 				box-sizing: border-box;
// 				color: white;
// 				margin-right: 32px;
// 			}
// 		}

// 		.tableBox {
// 			margin-top: 22px;
// 			border-top: 1px solid #e4e4e4;
// 		}

// 		.title {
// 			width: 83px;
// 			height: 28px;
// 			border-radius: 14px;
// 			background: #006eb7;
// 			font-size: 12px;
// 			text-align: center;
// 			line-height: 28px;
// 			color: white;
// 		}

// 		:deep(.el-table .el-table__cell) {
// 			padding: 17px 0 !important;
// 			white-space: pre-wrap !important;
// 		}
// 	}

// 	.video-content {
// 		cursor: pointer;
// 		width: 100%;
// 		height: 960px;
// 		background-color: white;
// 		margin-bottom: 100px;

// 		.video-title {
// 			width: 100%;
// 			height: 50px;
// 			// background-color: skyblue;
// 			// background-image: linear-gradient(rgb(212, 230, 255), white);

// 			// padding-left: 5px;
// 			line-height: 50px;
// 			display: flex;
// 			justify-content: space-between;
// 		}

// 		.video-bottom {
// 			height: 600px;
// 			width: 100%;
// 			display: flex;
// 			// flex-flow: column wrap;
// 			background-color: white;
// 			flex-wrap: wrap;

// 			.video-bottom-box {
// 				padding: 5px 10px;
// 				width: 20%;
// 				height: 158px;
// 				box-sizing: border-box;

// 				.box-img {
// 					width: 100%;
// 					height: 116px;
// 				}

// 				.video-img:hover {
// 					box-shadow: 5px 5px 5px gray;
// 				}

// 				.box-title {
// 					width: 100%;
// 					height: 21px;
// 					white-space: nowrap;
// 					/* 文本不换行 */
// 					overflow: hidden;
// 					/* 溢出部分隐藏 */
// 					text-overflow: ellipsis;
// 					padding-top: 5px;
// 					font-weight: 900;
// 				}

// 				.box-title:hover {
// 					color: rgb(32, 123, 255) !important;
// 				}

// 				.box-title2:hover {
// 					color: rgb(32, 123, 255) !important;
// 				}

// 				.box-title2 {
// 					color: gray;
// 					width: 100%;
// 					height: 21px;
// 					display: flex;
// 				}
// 			}
// 		}
// 	}
// }

.topInfo {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;

	.priceBox {
		width: 100%;
		// width: 989px;
		// margin-left: 210px;
		margin-top: 40px;
		// height: 365px;

		.productBox {
			position: relative;

			.imglogo {
				width: 92px;
				height: 81px;
				border-radius: 2.28px;
				position: absolute;
				bottom: 0;
				left: 24px;
				opacity: 1;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.produt {
				position: absolute;
				cursor: pointer;

				left: 125px;
				top: 50%;
				transform: translateY(-50%);
				font-weight: 400;
				font-size: 20px;
				letter-spacing: 0.1px;
				line-height: 23.4px;
				text-align: left;
				color: #fff;
			}
		}

		.location {
			margin-top: 10px;
			display: flex;
			align-items: center;
			transform: translateY(10px);
			height: 50px;

			.nav {
				// margin-top: 5px;
			}
		}

		.top {
			width: 100%;
			height: 167px;
			border-radius: 4px;
			background-color: white;
			padding: 12px 0;
			box-sizing: border-box;

			.title {
				width: 188px;
				height: 30px;
				border-radius: 0 4px 4px 0;
				background: #006eb7;
				text-align: center;
				line-height: 30px;
				color: white;
			}

			.contaionBox {
				margin-top: 21px;

				.line1 {
					width: 238px;
					height: 82px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					border-right: 1px solid #e4e4e4;

					.top2 {
						font-size: 28px;
					}

					.bottom {
						margin-top: 4px;
						display: flex;
						align-items: center;
						color: #21a00c;

						.left {
							padding: 0 10px;
							border-right: 2px solid #e4e4e4;
						}

						.right {
							padding: 0 10px;
						}
					}

					.bottom2 {
						margin-top: 4px;
						display: flex;
						align-items: center;
						color: #ff0c0c;

						.left {
							padding: 0 10px;
							border-right: 2px solid #e4e4e4;
						}

						.right {
							padding: 0 10px;
						}
					}
				}

				.line1:last-child {
					border-right: none;
				}
			}
		}
	}
}

.market {
	margin-top: 20px;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	// align-items: flex-start;

	.line2 {
		width: 350px;
		height: 476px;
		background-color: white;
		padding: 16px;
		// margin-right: 24px;
		box-sizing: border-box;

		.top {
			display: flex;
			align-items: center;

			.title {
				font-size: 16px;
				border-left: 3px solid #006eb7;
				padding-left: 5px;
			}

			.date {
				font-size: 10px;
				color: #aeaeae;
				margin-left: 6px;
			}
		}

		.theLine {
			height: 2px;
			background-color: #e4e4e4;
			margin-top: 7px;
			margin-bottom: 5px;
		}

		.contaion {
			.info {
				width: 70%;
				height: 50px;
				line-height: 50px;
			}

			.date {
				width: 30%;
				font-size: 16px;
				color: #909090;
			}
		}
	}

	.rightLine {
		width: 828px;
		height: 476px;

		.top3 {
			width: 828px;
			height: 227px;
			background-color: white;
			border-radius: 4px;
			padding: 16px;
			// margin-right: 24px;
			box-sizing: border-box;

			.top {
				display: flex;
				align-items: center;

				.title {
					font-size: 16px;
					border-left: 3px solid #006eb7;
					padding-left: 5px;
				}

				.date {
					font-size: 10px;
					color: #aeaeae;
					margin-left: 6px;
				}
			}

			.theLine {
				height: 2px;
				background-color: #e4e4e4;
				margin-top: 7px;
				margin-bottom: 5px;
			}

			.contaion {
				padding: 20px 30px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;

				.left {
					.btn {
						margin-bottom: 20px;
						width: 81px;
						height: 28px;
						border-radius: 14px;
						border: 1px solid #006eb7;
						color: #006eb7;
						box-sizing: border-box;
						text-align: center;
						line-height: 28px;
						font-size: 14px;
						cursor: pointer;
					}

					.btnBgc {
						background-color: #006eb7 !important;
						color: white !important;
						border: none !important;
					}
				}

				.right {
					width: 690px;
					display: flex;
					flex-wrap: wrap;

					.region {
						width: 33%;
						text-align: center;
						font-size: 23.85px;
						letter-spacing: 2.39px;
						cursor: pointer;
					}

					.region:first-child {
						margin-bottom: 44px;
					}
				}
			}
		}

		.top3 {
			margin-bottom: 22px;
			width: 828px;
			height: 227px;
			background-color: white;
			// padding: 16px;
			// margin-right: 24px;
			box-sizing: border-box;

			.top {
				display: flex;
				align-items: center;

				.title {
					font-size: 16px;
					border-left: 3px solid #006eb7;
					padding-left: 5px;
				}

				.date {
					font-size: 10px;
					color: #aeaeae;
					margin-left: 6px;
				}
			}

			.theLine {
				height: 2px;
				background-color: #e4e4e4;
				margin-top: 7px;
				margin-bottom: 7px;
			}

			.contaion2 {
				padding: 0 !important;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #e4e4e4;

				.info {
					width: 70%;
					height: 50px;
					line-height: 50px;
				}

				.date {
					width: 30%;
					font-size: 16px;
					color: #909090;
				}
			}

			.contaion2:last-child {
				border: none;
			}
		}
	}
}

.productBox {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	.productInfo {
		margin-right: 15px;
	}
}

.productInfo:nth-child(5n) {
	margin-right: 0;
}

.footBar {
	width: 1920px;
	height: 284px;
	background-color: #006eb7;
}

.information-bottom::-webkit-scrollbar {
	width: 8px;
}

.information-bottom::-webkit-scrollbar-thumb {
	border-radius: 20px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.information-bottom::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 0;
	background: rgba(0, 0, 0, 0.1);
}

.information-latest {
	cursor: pointer;
	width: 100%;
	height: 800px;
	background-color: white;

	.information-top {
		width: 100%;
		height: 50px;
		background-image: linear-gradient(rgb(212, 230, 255), white);
		line-height: 50px;
		display: flex;
		justify-content: space-between;
	}

	.information-bottom {
		width: 100%;
		height: 750px;

		overflow: auto;

		.box {
			width: 100%;
			height: 18%;
			// background-color: red;
			display: flex;
			margin-top: 12px;

			.box-left {
				width: 22%;
				height: 100%;
			}

			.box-right {
				width: 78%;
				height: 100%;
				// display: flex;
				padding: 10px 6px 6px 20px;

				.box-1 {
					height: 20%;
					width: 100%;
					padding-bottom: 8px;
					font-weight: 900;
				}

				.box-2 {
					height: 31%;
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}

				.box-2:hover {
					color: rgb(32, 123, 255) !important;
				}

				.box-3:hover {
					color: rgb(32, 123, 255) !important;
				}

				.box-3 {
					padding-top: 10px;
					height: 20%;
					width: 100%;
					color: gray;
					font-size: 14px;
				}
			}
		}
	}
}

.el-radio__label {
	padding-left: 0px !important;
}

::v-deep .el-radio {
	// width: 120px;
}

::v-deep .el-table .warning-row {
	background-color: #f3f7fc;
}

.bgc2 {
	background-color: white;
	color: #227bff !important;
}

.specialMargin {
	// background-color: yellow !important;
	left: -500% !important;
}


/* 自定义滚动条滑块样式 */
::v-deep.el-table__body-wrapper::-webkit-scrollbar-thumb {
	background-color: rgba(0, 0, 0, 0.2);
	/* 滑块颜色 */
	border-radius: 10px;
	/* 圆角 */
}


::v-deep .el-table__body-wrapper::-webkit-scrollbar {
	width: 14px;
	height: 10px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 0;
	width: 12px;
	background: rgba(0, 0, 0, 0.1);
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
	width: 12px;
	border-radius: 20px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

::v-deep .el-scrollbar__wrap::-webkit-scrollbar {
	width: 8px !important;
}

::v-deep.el-table__fixed-right-patch {
	width: 8px !important;
	background-color: #4472c4 !important;
}


/* 当鼠标悬停在滑块上时，改变滑块样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
	background-color: rgba(0, 0, 0, 0.4);
	/* 滑块悬停颜色 */
}

::v-deep .oneFen .el-dialog {
	background-color: black !important;
}


.has-gutter {
	height: 10px !important;
}

// ::v-deep .el-table__header-wrapper {
//   height: 30px !important;
//   line-height: 30px !important;
//   // margin-bottom:20px !important;
//   box-sizing: border-box
// }</style>
